/**
 * Example Movie Constellation Presets
 * Curated constellations for cinephile exploration
 */

import type { SavedMovieConstellation } from '../types/movie-explore.types';

export const EXAMPLE_MOVIE_CONSTELLATIONS: SavedMovieConstellation[] = [
  {
    id: 'french-new-wave',
    name: 'French New Wave',
    description: 'Godard-era Paris alienation and jump cuts',
    nodes: [
      { type: 'director', value: 'Jean-Luc Godard', weight: 0.9 },
      { type: 'country', value: 'France', weight: 0.7 },
      { type: 'era', value: '1960s', weight: 0.7 },
      { type: 'theme', value: 'Alienation', weight: 0.6 },
      { type: 'movement', value: 'French New Wave', weight: 0.8 },
    ],
    vibe: {
      pacing: 0.4,
      tone: 0.3,
      obscurity: 0.6,
      formalism: 0.7,
    },
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 'slow-cinema',
    name: 'Slow Cinema',
    description: 'Contemplative long takes and transcendent duration',
    nodes: [
      { type: 'director', value: 'Andrei Tarkovsky', weight: 0.9 },
      { type: 'mood', value: 'Contemplative', weight: 0.8 },
      { type: 'theme', value: 'Spirituality', weight: 0.7 },
      { type: 'movement', value: 'Slow Cinema', weight: 0.8 },
    ],
    vibe: {
      pacing: 0.05,
      tone: 0.4,
      obscurity: 0.6,
      formalism: 0.8,
    },
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 'romanian-new-wave',
    name: 'Romanian New Wave',
    description: 'Social realism under post-communist moral weight',
    nodes: [
      { type: 'director', value: 'Cristian Mungiu', weight: 0.8 },
      { type: 'country', value: 'Romania', weight: 0.9 },
      { type: 'movement', value: 'Romanian New Wave', weight: 0.8 },
      { type: 'theme', value: 'Social realism', weight: 0.7 },
      { type: 'era', value: '2000s', weight: 0.6 },
    ],
    vibe: {
      pacing: 0.2,
      tone: 0.2,
      obscurity: 0.7,
      formalism: 0.3,
    },
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 'iranian-poetry',
    name: 'Iranian Poetry',
    description: 'Kiarostami and meditative road movie poetics',
    nodes: [
      { type: 'director', value: 'Abbas Kiarostami', weight: 0.9 },
      { type: 'country', value: 'Iran', weight: 0.8 },
      { type: 'mood', value: 'Meditative', weight: 0.7 },
      { type: 'genre', value: 'Road movie', weight: 0.6 },
    ],
    vibe: {
      pacing: 0.15,
      tone: 0.5,
      obscurity: 0.65,
      formalism: 0.5,
    },
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 'italian-masters',
    name: 'Italian Masters',
    description: 'Fellini dream logic and 1960s Italian excess',
    nodes: [
      { type: 'director', value: 'Federico Fellini', weight: 0.9 },
      { type: 'country', value: 'Italy', weight: 0.7 },
      { type: 'era', value: '1960s', weight: 0.7 },
      { type: 'theme', value: 'Dream logic', weight: 0.8 },
    ],
    vibe: {
      pacing: 0.35,
      tone: 0.6,
      obscurity: 0.55,
      formalism: 0.75,
    },
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 'korean-contemporary',
    name: 'Korean Contemporary',
    description: 'Park Chan-wook class tension and stylized violence',
    nodes: [
      { type: 'director', value: 'Park Chan-wook', weight: 0.8 },
      { type: 'country', value: 'South Korea', weight: 0.8 },
      { type: 'theme', value: 'Class conflict', weight: 0.7 },
      { type: 'mood', value: 'Tension', weight: 0.7 },
    ],
    vibe: {
      pacing: 0.65,
      tone: 0.25,
      obscurity: 0.5,
      formalism: 0.8,
    },
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 'american-indie-90s',
    name: 'American Indie 90s',
    description: 'Jarmusch deadpan and lo-fi American drifting',
    nodes: [
      { type: 'director', value: 'Jim Jarmusch', weight: 0.8 },
      { type: 'country', value: 'USA', weight: 0.7 },
      { type: 'era', value: '1990s', weight: 0.7 },
      { type: 'mood', value: 'Deadpan', weight: 0.8 },
      { type: 'movement', value: 'American Independent', weight: 0.7 },
    ],
    vibe: {
      pacing: 0.2,
      tone: 0.45,
      obscurity: 0.6,
      formalism: 0.35,
    },
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  {
    id: 'japanese-minimalism',
    name: 'Japanese Minimalism',
    description: 'Ozu domestic geometry and postwar family quiet',
    nodes: [
      { type: 'director', value: 'Yasujiro Ozu', weight: 0.9 },
      { type: 'country', value: 'Japan', weight: 0.8 },
      { type: 'theme', value: 'Domestic life', weight: 0.7 },
      { type: 'era', value: '1950s', weight: 0.7 },
    ],
    vibe: {
      pacing: 0.1,
      tone: 0.55,
      obscurity: 0.5,
      formalism: 0.7,
    },
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
];
